import React, { useState, useEffect } from 'react';

import AutocompleteFieldWithFallback from './AutocompleteFieldWithFallback';
import LocationAutocompleteGoogle from './LocationAutocompleteGoogle';

export default function LocationAutocomplete(props) {
    const [isInBrowser, setIsInBrowser] = useState(false);

    useEffect(() => setIsInBrowser(true), [setIsInBrowser]);

    return isInBrowser ? (
        <LocationAutocompleteGoogle {...props} />
    ) : (
        <AutocompleteFieldWithFallback
            id="location-autocomplete-fallback"
            placeholder={props.currentPlace || ''}
        />
    );
}
